// eslint-disable-next-line import/no-cycle
import { getMessageTimeConfig } from '@/api/messageManage'
import { getPaymentMethods } from '@/api/purchaseAndSaleAPI'
import { getVehicleState } from '@/api/carManage'
import { paymentMethodsTip, moneyTip, payPost, presentDays, rentCalculationRuleTip } from '@/config/carManage'
import { getCityList } from '@/api/domain/cars'
import { checkRentMallOpen, checkLeasePlanCalculateOpen } from '@/api/domain/others'
import { getRegions } from '@/api/global'

const global = {
  state: {
    allCities: [],
    cityCodeMap: {},
    authInfo: null,
    brandList: [], // 租户下的所有品牌（跟当前登录权限的账号关联）
    smsConfig: null, // 短信推送云控返回时间信息
    phoneConfig: null, // 语音推送云控返回时间信息
    breadcrumb: [],
    freeTypeList: [], // 财务费项枚举
    categoryList: [], // 租赁类别枚举
    paymentMethods: [], // 付款方式
    rentOrderFeeList: [], // 个人订单费项枚举
    settleMentFeeList: [], // 结算费项枚举
    paymentMethodsTip,
    moneyTip,
    payPost,
    presentDays,
    carStateList: {}, // 车辆状态枚举
    carWorkStateList: {}, // 车务状态枚举
    rentCalculationRuleTip, // 不足月租金计算规则
    todoCount: 0, // 待办数量
    paymentTypeList: [], // 付款类型
    advancePaymentList: [], // 发车前收款
    rentMallOpenSwitch: false, // 租户是否开启租赁商城开关
    newCalculationOpenSwitch: false, // 新版计租配置开关
    bankChannelType: 6, // 清分渠道
    bankChannelName: '', // 清分渠道名称
    areaLinkageProvinceList: [], // 区域联动省份列表
  },
  mutations: {
    SET_BREADCRUMB: (state, breadcrumb) => {
      state.breadcrumb = breadcrumb
    },
    // 设置全部城市
    SET_ALL_CITIES: (state, cities) => {
      state.allCities = cities
      // 城市codeMap，方便前端反显城市中文
      state.cityCodeMap = cities.reduce((total, i) => {
        const obj = {}
        obj[Number(i.adcode)] = i.city
        total = Object.assign(total, obj)
        return total
      }, {})
    },
    // 设置租赁商城开关
    SET_RENT_MALL_OPEN_SWITCH: (state, status) => {
      state.rentMallOpenSwitch = status
    },
    // 设置新版计租配置开关
    SET_NEW_CALCULATION_OPEN_SWITCH: (state, status) => {
      state.newCalculationOpenSwitch = status
    },
    // 设置当前授权的租户信息包括租户ID和当前token
    SET_AUTH_INFO: (state, authInfo) => {
      state.authInfo = authInfo
    },
    SET_SMSCONFIG: (state, data) => {
      state.smsConfig = data
    },
    SET_PHONECONFIG: (state, data) => {
      state.phoneConfig = data
    },
    // 财务费项枚举
    SET_FREETYPE_LIST: (state, data) => {
      state.freeTypeList = data
    },
    // 租赁类别枚举
    SET_CATEGORY_LIST: (state, data) => {
      state.categoryList = data
    },
    // 付款方式
    SET_PAYMENT_METHODS: (state, data) => {
      state.paymentMethods = data
    },
    // 发车前收款
    SET_ADVANCE_PAYMENT: (state, data) => {
      state.advancePaymentList = data
    },
    // 个人订单费项枚举
    SET_RENTORDERFEE_LIST: (state, data) => {
      state.rentOrderFeeList = data
    },
    // 结算费项枚举
    SET_SETTLEMENT_LIST: (state, data) => {
      state.settleMentFeeList = data
    },
    // 付款类型枚举
    SET_PAYMENTTYPE_LIST: (state, data) => {
      state.paymentTypeList = data
    },
    SET_CARSTATE_LIST: (state, list) => {
      state.carStateList = list
    },
    SET_CARWORKSTATE_LIST: (state, list) => {
      state.carWorkStateList = list
    },
    // 设置待办数量
    SET_TODO_COUNT: (state, count) => {
      state.todoCount = count
    },
    SET_BANK_CHANNEL_TYPE: (state, channelType) => {
      state.bankChannelType = channelType
    },
    SET_BANK_CHANNEL_NAME: (state, channelName) => {
      state.bankChannelName = channelName
    },
    // 设置区域联动省份的列表
    SET_AREALINKAGE_PROVINCE_LIST: (state, list) => {
      state.areaLinkageProvinceList = list
    },
  },
  actions: {
    // 获取全部城市
    getCityListFn({ commit }) {
      return new Promise((resolve, reject) => {
        getCityList().then((data) => {
          if (data.code === 1) {
            commit('SET_ALL_CITIES', data.data || [])
            resolve(data)
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // 获取租户是否开启过租赁商城
    getRentMallOpenSwitchFn({ commit }) {
      return new Promise((resolve, reject) => {
        checkRentMallOpen({}).then((data) => {
          if (data.code === 1) {
            resolve(data)
            commit('SET_RENT_MALL_OPEN_SWITCH', data.data)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
    // 获取租户是否开启新版计租配置
    getLeasePlanCalculateOpenFn({ commit }, params = {}) {
      return new Promise((resolve, reject) => {
        checkLeasePlanCalculateOpen(params).then((data) => {
          if (data.code === 1) {
            resolve(data)
            commit('SET_NEW_CALCULATION_OPEN_SWITCH', data.data)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
    smsConfigFn({ commit }) {
      try {
        getMessageTimeConfig({ businessType: 2 })
          .then((data) => {
            let timeVal = ['7', '00', '21', '30']
            if (data.code === 1 && data.data) {
              const { sendTimeStart, sendTimeEnd } = data.data
              timeVal = [...sendTimeStart.split(':'), ...sendTimeEnd.split(':')]
              if (Number(timeVal[0]) < 10) {
                timeVal[0] = timeVal[0].substring(1, 2)
              }
            }
            commit('SET_SMSCONFIG', timeVal)
          })
      } catch (error) {
        console.log('云控短信发送时间err', error)
      }
    },
    phoneConfigFn({ commit }) {
      try {
        getMessageTimeConfig({ businessType: 3 })
          .then((data) => {
            let timeVal = ['7', '00', '21', '30']
            if (data.code === 1 && data.data) {
              const { sendTimeStart, sendTimeEnd } = data.data
              timeVal = [...sendTimeStart.split(':'), ...sendTimeEnd.split(':')]
              if (Number(timeVal[0]) < 10) {
                timeVal[0] = timeVal[0].substring(1, 2)
              }
            }
            commit('SET_PHONECONFIG', timeVal)
          })
      } catch (error) {
        console.log('云控语音发送时间err', error)
      }
    },
    SetAuthInfo({ commit }, params = {}) {
      commit('SET_AUTH_INFO', params)
    },
    // 获取车辆状态和车务状态
    getVehicleState({ commit }) {
      getVehicleState().then((res) => {
        const { code, data } = res
        if (code === 1) {
          const carStateList = {}
          const carWorkStateList = {}
          data.forEach((item) => {
            if (item.type === 'carState') {
              carStateList[item.code] = item.name
            } else {
              carWorkStateList[item.code] = item.name
            }
          })
          commit('SET_CARSTATE_LIST', carStateList)
          commit('SET_CARWORKSTATE_LIST', carWorkStateList)
        }
      })
    },
    // 获取付款方式和收款类型
    getPaymentMethods({ commit }, params = {}) {
      const commitParams = {
        payMode: 'SET_PAYMENT_METHODS', // 付款方式
        financeFeeType: 'SET_FREETYPE_LIST', // 财务费项枚举
        rentCategory: 'SET_CATEGORY_LIST', // 租赁类别枚举
        rentOrderFeeType: 'SET_RENTORDERFEE_LIST', // 个人订单费项枚举（未区分租车、以租代扣、司机合作模式）
        settlementFeeType: 'SET_SETTLEMENT_LIST', // 结算费项枚举
        paymentType: 'SET_PAYMENTTYPE_LIST', // 获取付款类型
        advancePayment: 'SET_ADVANCE_PAYMENT', // 发车前收款
        orderSignRentFee: 'SET_RENTORDERFEE_LIST', // 类型为【租车】的费项 - 也属于个人订单费项枚举
        orderSignPurchaseFee: 'SET_RENTORDERFEE_LIST', // 类型为【以租代购】的费项 - 也属于个人订单费项枚举
        orderSignCooperateFee: 'SET_RENTORDERFEE_LIST', // 类型为【司机合作模式】的费项 - 也属于个人订单费项枚举
      }
      return new Promise((resolve, reject) => {
        // ~~~~~~ 临时解法
        if (!params.type) {
          console.error(`'入参params:' + ${params.type}`)
          reject()
          return
        }
        // ~~~~~~ 临时解法
        getPaymentMethods(params).then((res) => {
          commit(commitParams[params.type], res.data)
          resolve(res)
        }).catch((error) => {
          console.error('获取收付款枚举数据异常', error)
          reject(error)
        })
      })
    },
    // 维保商城维度-区域联动省份列表
    getAreaLinkageProvinceList({ commit }) {
      getRegions({ areaType: 1 }).then(({ code, data }) => {
        if (code === 1) {
          commit('SET_AREALINKAGE_PROVINCE_LIST', data)
        }
      })
    },
  },
}
export default global
